mutation UserProfileInvite($input: UserProfileInviteInput!) {
  userProfileInvite(input: $input) {
    inviteResults {
      isValid
      warningMessage
      userProfile {
        id
        __typename
        _rowTimestamp
        name
        emailAccount
        invited
        _invitationStatusTypeId
        inviteStatusType {
          statusType
        }
        _isStagedToInvite
        _statusTypeId
        statusType {
          statusType
          approvalState
        }
      }
    }
  }
}